module.exports = __webpack_public_path__ + "img/afologo.56ef020a.svg";